import noImage from "@/assets/no_available.png";
import { LoaderIcon } from "@/components/loader/LoaderIcon";
import { getImageUrl } from "@/lib/services/images";
import { useEffect, useState } from "react";

const noImageUrl = new URL(noImage, import.meta.url).href;

type Props = {
  imageId: number;
};

const Image = ({ imageId }: Props) => {
  const [photoURL, setPhotoURL] = useState<string>(noImageUrl);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    const handleOnGetURL = async () => {
      if (!imageId) {
        setPhotoURL(noImageUrl);
        setLoading(false);
        return;
      }
      try {
        const imageUrl = await getImageUrl(imageId);
        if (!imageUrl) {
          setPhotoURL(noImageUrl);
        } else {
          setPhotoURL(imageUrl);
        }
      } catch (error) {
        console.error("Error fetching image URL:", error);
        setPhotoURL(noImageUrl);
      } finally {
        setLoading(false);
      }
    };

    handleOnGetURL();
  }, [imageId]);

  if (loading) {
    return (
      <div
        data-testid="image-laoder"
        className="flex items-center justify-center bg-gray-100 rounded-md py-16"
      >
        <LoaderIcon className="animate-spin-slow" />
      </div>
    );
  }

  return (
    <div data-testid="image-load" className="py-2 max-h-[400px]">
      <img
        src={photoURL}
        alt="Foto"
        className="block max-h-[400px] max-w-full w-auto object-contain rounded-md mx-auto"
        onError={(e) => {
          // Si la URL existe pero la descarga falla (S3 403, 404, etc.)
          e.currentTarget.onerror = null;
          e.currentTarget.src = noImageUrl;
        }}
      />
    </div>
  );
};

export default Image;
